import { NullableString, Preferito, ServiceDescriptor } from "../models/ServiceDescriptor"

export type OptionType = {
    label: string,
    value: NullableString | number,
}

export type EditPrefType = {
    show: boolean 
    appl?: ServiceDescriptor
    preferito?: Preferito
    iconName?: string
    color?: string
    title?: string
}

export const sdSezioni = ['Applicazioni', 'Circolari', 'Link Utili']
export const sdSezioniOptions: OptionType[] = [{label: 'Applicazioni', value: 'Applicazioni'}, {label: 'Circolari', value: 'Circolari'}, {label: 'Link Utili', value: 'Link Utili'}]

export const livelli = ['Sixtema', 'Azienda', 'Nazionale', 'Regionale', 'Provincia', 'Ufficio']
export const livelliOptions: OptionType[] = [{label: 'Sixtema', value: 'Sixtema'}, {label: 'Azienda', value: 'Azienda'}, {label: 'Nazionale', value: 'Nazionale'},
                        {label: 'Regionale', value: 'Regionale'}, {label: 'Provincia', value: 'Provincia'},{label: 'Ufficio', value: 'Ufficio'}]

export const tipoAppl = ['HtmlSso', 'HtmlSsoSix', 'HtmlSsoSix2', "HtmlSsoTx", 'HtmlSimple', 'Osr', 'Circolare']
export const tipoApplOptions: OptionType[] = [
    {label: 'HtmlSso', value: 'HtmlSso'}, 
    {label: 'HtmlSsoSix', value: 'HtmlSsoSix'}, 
    {label: 'HtmlSsoSix2', value: 'HtmlSsoSix2'},
    {label: 'HtmlSsoTx', value: 'HtmlSsoTx'},
    {label: 'HtmlSimple', value: 'HtmlSimple'}, 
    {label: 'Osra', value: 'Osra'},
    {label: 'Circolare', value: 'Circolare'}
]
export const ambienti = [null, 'PROD', 'BUDG', 'ALFA']
export const ambientiOptions: OptionType[] = [{label: 'Tutti', value: null},{label: 'PROD', value: 'PROD'}, {label: 'BUDG', value: 'BUDG'}, {label: 'ALFA', value: 'ALFA'}]
